import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import MediaModel from "../../MediaUpload/MediaModel";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
const EditBlog = () => {
  const { id } = useParams();
 const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const imageInputRef = useRef(null);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [shortContent, setShortContent] = useState("");
  const [editData, setEditData] = useState([]);
  const [error, setError] = useState(null);
  
  useEffect(async () =>  {
    try {
            setError(null);
            const response = await fetch(`${baseurl}/admin/blogs/${id}`);
            if (!response.ok) throw new Error("Network response was not ok");
            const data = await response.json();
            setEditData(data);
            setShortContent(data?.blog_discription || "");
            setUploadedImages([data?.blog_img]);
          } catch (error) {
            setError(error.message);
          }
      
    
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: editData?.id || "",
      title: editData?.title || "",
      category: editData?.category || "",
      published_date: editData?.cdate ? new Date(editData.cdate).toISOString().slice(0, 10) : "",
      status: editData?.status || "",
      images: editData?.image || "",
      metaTitle: editData?.meta_title || "",
      metaDescription: editData?.meta_description	 || "",
      metaKeywords: editData?.meta_keywords || "",
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Please enter the title"),
      category: Yup.string().required("Please select category"),
      published_date: Yup.string().required("Please select date"),
      status: Yup.string().required("Please select the status"),

      // FIXED → allow existing image OR new image
      images: Yup.mixed().test(
        "fileSelected",
        "Please select an image",
        () => uploadedImages && uploadedImages.length > 0
      ),

      metaTitle: Yup.string().required("Meta title is required"),
      metaDescription: Yup.string()
        .required("Meta description is required")
        .max(180, "Meta description cannot exceed 180 characters"),
      metaKeywords: Yup.string().required("Meta keywords are required"),
    }),

    onSubmit: async (values) => {
      try {
        const res = await fetch(`${baseurl}/admin/blogs/update/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: values.title,
            category: values.category,
            blog_img: uploadedImages ? uploadedImages[0] : "", // string URL only
            cdate: values.published_date,
            blog_discription: shortContent,
            meta_title: values.metaTitle,
            meta_description: values.metaDescription,
            meta_keywords: values.metaKeywords,
            status: values.status,
          }),
        });

        const data = await res.json();
        console.log("Response:", data);

        if (data.success) {
          toast.success('Blog Updated Successfully!!', 'success');
          
        }
      } catch (err) {
        console.error("Blog Update Error:", err);
      }
    },
  });

  // HANDLE QUILL CONTENT
  const handleShortContentChange = (newContent) => {
    setShortContent(newContent);
  };

  const toggleImageModal = () => {
    setImageModel(!imageModel);
    setSelectedImage([]);
  };

  
  const handleUploadImage = (image) => {
    if (image) {
      setUploadedImages([image[0].fileurl]);
    }
    toggleImageModal();
    setSelectedImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      setUploadedImages([newImage]);
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Blog" breadcrumbItem="Edit blog" />

          {/* MAIN BLOG FORM */}
          <Card>
            <CardBody>
              <Row>
                {/* Title */}
                <Col md={6}>
                  <div className="mb-3">
                    <Label>Blog Title</Label>
                    <Input
                      name="title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                      invalid={formik.touched.title && formik.errors.title}
                    />
                    <FormFeedback>{formik.errors.title}</FormFeedback>
                  </div>
                </Col>

               

                {/* CATEGORY */}
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label>Select Category</Label>
                                    <Input
                                      name="category"
                                      type="select"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.category}
                                      invalid={
                                        formik.touched.category &&
                                        Boolean(formik.errors.category)
                                      }
                                    >
                                      <option value="">Select Category</option>
                                      <option value="Life Style">Life Style</option>
                                      <option value="Technology">Technology</option>
                                      <option value="Business">Business</option>
                                      <option value="Others">Others</option>
                                      <option value="Entertainment">Entertainment</option>
                                      <option value="Fashion">Fashion</option>
                                    </Input>
                                    <FormFeedback>{formik.errors.category}</FormFeedback>
                                  </div>
                                </Col>
                
                                {/* DATE */}
                                <Col sm={3}>
                                  <div className="mb-3">
                                    <Label>Date</Label>
                                    <Input
                                      name="published_date"
                                      type="date"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.published_date}
                                      invalid={
                                        formik.touched.published_date &&
                                        Boolean(formik.errors.published_date)
                                      }
                                    />
                                    <FormFeedback>{formik.errors.published_date}</FormFeedback>
                                  </div>
                                </Col>
                
                                {/* STATUS */}
                                <Col sm={3}>
                                  <div className="mb-3">
                                    <Label>Status</Label>
                                    <Input
                                      name="status"
                                      type="select"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.status}
                                      invalid={
                                        formik.touched.status &&
                                        Boolean(formik.errors.status)
                                      }
                                    >
                                      <option value="">Select Status</option>
                                      <option value="Active">Active</option>
                                      <option value="Inactive">Inactive</option>
                                    </Input>
                                    <FormFeedback>{formik.errors.status}</FormFeedback>
                                  </div>
                                </Col>
                
                                {/* IMAGE UPLOAD */}
                                <Col sm={6}>
                                  <div className="mb-3">
                                    <Label>Blog Image</Label>
                
                                    <div
                                      className="custom-file-button"
                                      onClick={toggleImageModal}
                                    >
                                      <i className="bx bx-cloud-upload me-2"></i>Choose Image
                                    </div>
                
                                    <Input
                                      name="images"
                                      type="file"
                                      accept="image/*"
                                      innerRef={imageInputRef}
                                      onChange={handleImageChange}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                </Col>
                
                                {uploadedImages && (
                                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                          <div className="p-2">
                                            <Row className="d-flex justify-content-between align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="100"
                                                  width="100"
                                                  className="avatar-md rounded bg-light"
                                                  alt="images"
                                                  src={imgurl + uploadedImages}
                                                />
                                              </Col>
                                              <Col className="col-auto">
                                                <button
                                                  type="button"
                                                  className="btn btn-danger btn-sm"
                                                  onClick={() => {
                                                    setUploadedImages(null);
                                                  }}
                                                >
                                                  Delete
                                                </button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      )}

                {/* DESCRIPTION */}
                <Col sm={12} className="mb-5">
                  <Label>Blog Description</Label>
                  <ReactQuill
                    theme="snow"
                    value={shortContent}
                    onChange={handleShortContentChange}
                    style={{ height: "300px" }}
                  />
                </Col>

                
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle>Meta Data</CardTitle>

              <Row>
                <Col sm={6}>
                  <div className="mb-3">
                    <Label className="form-label">Meta title</Label>
                    <Input
                      name="metaTitle"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaTitle}
                      invalid={
                        formik.touched.metaTitle && formik.errors.metaTitle
                      }
                    />
                    <FormFeedback>{formik.errors.metaTitle}</FormFeedback>
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Meta Keywords</Label>
                    <Input
                      name="metaKeywords"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaKeywords}
                      invalid={
                        formik.touched.metaKeywords &&
                        formik.errors.metaKeywords
                      }
                    />
                    <FormFeedback>{formik.errors.metaKeywords}</FormFeedback>
                  </div>
                </Col>

                <Col sm={6}>
                  <Label className="form-label">
                    Meta Description (Max 180 Characters)
                  </Label>
                  <textarea
                    name="metaDescription"
                    className="form-control"
                    rows="5"
                    maxLength="180"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.metaDescription}
                  />

                  {formik.touched.metaDescription &&
                    formik.errors.metaDescription && (
                      <div className="text-danger">
                        {formik.errors.metaDescription}
                      </div>
                    )}
                </Col>
                <Col className="text-end mt-4">
                  <Button color="success" onClick={formik.handleSubmit}>
                    Update
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>

          

          {/* Image modal */}
          <MediaModel
            imageModel={imageModel}
            toggleModal={toggleImageModal}
            handleUploadImage={handleUploadImage}
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        </Container>
      </div>
    </>
  );
};

export default EditBlog;
